$(document).on('turbo:load turbo:render', () => {
    if ($(".entity-info").data()) {
        let hide = $(".entity-info").data().hide;
        if (hide) {
            $(".entity-info").hide();
            let $select = $('.entity-info').find("select");
            if ($select.is(":hidden")) {
                $select.prop("disabled", true);
            }

            $('.entity-info').find('input').each(function () {
                //your code here
                if ($(this).is(":hidden")) {
                    $(this).prop("disabled", true);
                }
            });
        }


        $("#revealAddEntity").on('click', () => {

            $(".entity-info").toggle();
            $('.entity-info').find('input').each(function () {
                //your code here
                if ($(this).is(":hidden")) {
                    $(this).prop("disabled", true);
                } else if ($(this).is(":visible")) {
                    $(this).prop("disabled", false);

                }

            });


        });
    }

    $(".organization-info").hide();
    // $("#revealAddOrganization").on('click', () => {
    //     $(".organization-info").toggle()
    // })
});